module.exports = __webpack_public_path__ + "media/images/tiedye/design-9-71bad553c3a9736c6e784156a2a880f5.jpg";